import React, { useEffect, useState } from 'react';
import './launch-modal.css';

// Course-launch / "enroll now" posters shown to visitors on landing.
// Files live in public/posters; names have spaces so they are URL-encoded.
const LAUNCH_POSTERS = [
  { file: 'Caurse lanuch (1) (1).jpeg', alt: 'S-CUBUS NEET course launch — Enroll now' },
  { file: 'Caurse lanuch (1) (1)2.jpeg', alt: 'S-CUBUS JEE course launch — Enroll now' },
].map((p) => ({ ...p, src: `/posters/${encodeURIComponent(p.file)}` }));

interface LaunchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LaunchModal: React.FC<LaunchModalProps> = ({ isOpen, onClose }) => {
  const close = () => onClose();

  // Close on Escape, and lock background scroll while open.
  useEffect(() => {
    if (!isOpen) return;

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="launch-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Course launch announcement"
      onClick={close}
    >
      {/* Stop propagation so clicking the poster itself doesn't close it */}
      <div className="launch-dialog" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="launch-close"
          onClick={close}
          aria-label="Close"
        >
          &times;
        </button>
        <div className="launch-posters">
          {LAUNCH_POSTERS.map((poster) => (
            <img key={poster.src} src={poster.src} alt={poster.alt} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LaunchModal;
